import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function RecentIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 24 24'
    >
      <path
        d='M12 6.375C12.6213 6.375 13.125 6.87868 13.125 7.5V12C13.125 12.6213 12.6213 13.125 12 13.125C11.3787 13.125 10.875 12.6213 10.875 12V7.5C10.875 6.87868 11.3787 6.375 12 6.375Z'
        fill={props.fill ?? '#3B3C40'}
      />
      <path
        d='M11.0257 11.438C11.3362 10.8998 12.0242 10.7152 12.5624 11.0257L16.4624 13.2757C17.0006 13.5862 17.1851 14.2742 16.8746 14.8124C16.5642 15.3506 15.8762 15.5351 15.338 15.2246L11.438 12.9746C10.8998 12.6642 10.7152 11.9762 11.0257 11.438Z'
        fill={props.fill ?? '#3B3C40'}
      />
      <path
        d='M21.0186 4.47266C21.6399 4.47266 22.1436 4.97634 22.1436 5.59766V9.34766C22.1436 9.96898 21.6399 10.4727 21.0186 10.4727H17.2686C16.6472 10.4727 16.1436 9.96898 16.1436 9.34766C16.1436 8.72634 16.6472 8.22266 17.2686 8.22266H19.8936V5.59766C19.8936 4.97634 20.3972 4.47266 21.0186 4.47266Z'
        fill={props.fill ?? '#3B3C40'}
      />
      <path
        d='M13.3873 5.01233C12.005 4.73694 10.5721 4.8777 9.26984 5.41681C7.96758 5.95591 6.85446 6.86914 6.0713 8.04096C5.28814 9.21279 4.87012 10.5906 4.87012 12C4.87012 13.4094 5.28814 14.7872 6.0713 15.959C6.85446 17.1309 7.96758 18.0441 9.26984 18.5832C10.5721 19.1223 12.005 19.2631 13.3873 18.9877C14.7695 18.7123 16.0391 18.0331 17.0353 17.0361C17.4745 16.5966 18.1868 16.5963 18.6263 17.0354C19.0658 17.4746 19.0661 18.1869 18.6269 18.6264C17.3161 19.9383 15.6457 20.8319 13.8269 21.1943C12.0081 21.5567 10.1227 21.3715 8.40923 20.6621C6.69572 19.9528 5.2311 18.7511 4.20062 17.2093C3.17014 15.6674 2.62012 13.8545 2.62012 12C2.62012 10.1455 3.17014 8.33261 4.20062 6.79074C5.2311 5.24886 6.69572 4.04725 8.40923 3.3379C10.1227 2.62856 12.0081 2.44335 13.8269 2.8057C15.6452 3.16796 17.3153 4.06124 18.6259 5.37256C18.6263 5.3729 18.6266 5.37324 18.6269 5.37358L21.813 8.55021C22.2529 8.98891 22.254 9.70122 21.8153 10.1412C21.3766 10.5812 20.6643 10.5822 20.2243 10.1435L17.0368 6.96542L17.0353 6.96393C16.0391 5.96689 14.7695 5.28773 13.3873 5.01233Z'
        fill={props.fill ?? '#3B3C40'}
      />
    </SvgIcon>
  );
}
